export default __webpack_public_path__ + "static/media/MacRA-Design_ICONE_Grade-control-structures.20d3b500.jpg";